module.exports = __webpack_public_path__ + "static/media/convnet.36104223.png";